/* eslint-disable import/no-cycle */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import { Box, Typography, Collapse } from '@mui/material';
import dayjs from 'dayjs';
import CardContainerServices from './CardContainerServices';
import { convertDecimalToHora } from '../../../../utils/general';
import Loader from '../../../../components/shared/Loader';
import CollapseBox from '../../CollapseBox';
import { Destination, Version } from '../../../../utils/types/ProjectType';
import VersionDropdown from '../../VersionDropdown';

interface Props {
  dayChecked: string;
  destinations: Destination[];
  detailProjectId: string;
  onLoadVersion: (id: string) => void;
  projectName?: string;
  projectType: string;
  typeView: any;
  utcUpadtedAt: string;
  versions: Version[];
}
const ServicesTimeContainer: React.FC<Props> = function ServicesTimeContainer({
  detailProjectId,
  projectType,
  typeView,
  dayChecked,
  utcUpadtedAt,
  destinations,
  projectName,
  versions,
  onLoadVersion
}) {
  const currentDate = new Date();
  const formattedDateToday = dayjs(currentDate).format('D/M/YYYY');

  const [openDestination, setOpenDestination] = useState<{
    [destinationId: string]: boolean;
  }>({});

  const [openServiceId, setOpenServiceId] = useState<number | null>(null);

  useEffect(() => {
    if (destinations?.length > 0) {
      const firstDestinationId = String(destinations[0].id);
      setOpenDestination({ [firstDestinationId]: true });
    }
    if (
      destinations?.length > 0 &&
      destinations[0].serviceTimes[0].services.length > 0
    ) {
      setOpenServiceId(destinations[0].serviceTimes[0].id);
    }
  }, [destinations]);

  // Ensure only one collapse is open at a time
  const toggleDestination = (destinationId: string) => {
    setOpenDestination((prev) => {
      const isCurrentlyOpen = !!prev[destinationId];
      return { [destinationId]: !isCurrentlyOpen };
    });
  };

  const toggleService = (serviceId: number) => {
    setOpenServiceId((prevId) => (prevId === serviceId ? null : serviceId));
  };

  const headerServiceTme = () => {
    return (
      <Box
        sx={{
          alignItems: 'center',
          background: '#F5F6F8',
          border: '1px solid #E2E4EA',
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'row',
          gap: 2,
          justifyContent: 'space-between',
          px: 2,
          py: '10px'
        }}
      >
        <Box sx={{ alignItems: 'center', display: 'flex', gap: 1 }}>
          <i
            className="custom-icon icon-clock"
            style={{ color: '#005DA2', fontSize: 14 }}
          />
          <Typography
            sx={{ color: '#0f1c2e', fontSize: '13px', fontWeight: 700 }}
          >
            {projectType === 'Regular'
              ? 'Regular Service Times'
              : 'Ad-Hoc Service Times'}
          </Typography>
          {projectType === 'Ad-Hoc' && (
            <Box
              sx={{
                alignItems: 'center',
                background: '#F5F6F8',
                border: '1px solid #E2E4EA',
                borderRadius: '6px',
                display: 'flex',
                gap: '4px',
                px: '8px',
                py: '2px'
              }}
            >
              <Typography
                color="secondary.400"
                fontSize={11}
                variant="secondary"
              >
                Travel time (round trip):
              </Typography>
              <Typography
                color="secondary.500"
                fontSize={12}
                fontWeight={600}
                variant="primary-bold"
              >
                {`${convertDecimalToHora(
                  Number(destinations[0]?.serviceTimes[0]?.travelTime)
                )}`}
              </Typography>
            </Box>
          )}
        </Box>
        <VersionDropdown
          currentProjectId={detailProjectId}
          onChange={onLoadVersion}
          versions={versions}
        />
      </Box>
    );
  };

  if (destinations?.length <= 0 || !projectType) {
    return (
      <Box
        style={{ width: '100%' }}
        sx={{
          display: 'flex',
          flexGrow: 1,
          padding: '5px'
        }}
      >
        <Loader customColor="primary" />
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box display="flex" flexDirection="column">
        {headerServiceTme()}
      </Box>

      <Box display="flex" flexDirection="column" gap={2}>
        {destinations.map((destination) => (
          <CollapseBox
            destination={destination}
            isCollapseOpen={openDestination[destination.id]}
            key={destination.id}
            projectSetupTab="serviceAndTask"
            projectType={projectType}
            toggleDestination={() => toggleDestination(String(destination.id))}
          >
            <Collapse
              unmountOnExit
              in={!!openDestination[String(destination.id)]}
              timeout="auto"
            >
              <Box
                display="flex"
                flexDirection="column"
                gap={2.5}
                marginTop={2.5}
              >
                {destination &&
                  destination.serviceTimes?.length > 0 &&
                  destination.serviceTimes.map((serviceTime, index: number) => {
                    return (
                      <CardContainerServices
                        count={`${index + 1}`}
                        data={serviceTime}
                        dayChecked={
                          typeView === 'calendar'
                            ? dayjs(dayChecked).format('D/M/YYYY')
                            : formattedDateToday
                        }
                        detailProjectId={detailProjectId}
                        isOpen={openServiceId === serviceTime.id}
                        key={serviceTime.id}
                        projectName={projectName}
                        projectType={projectType}
                        setIsOpen={() => toggleService(serviceTime.id)}
                        type="serviceTime"
                        typeView={typeView}
                        utcUpadtedAt={utcUpadtedAt}
                      />
                    );
                  })}
              </Box>
            </Collapse>
          </CollapseBox>
        ))}
      </Box>
    </Box>
  );
};
export default ServicesTimeContainer;
